import { render } from "./Destinations.vue?vue&type=template&id=309e302a&scoped=true"
import script from "./Destinations.vue?vue&type=script&lang=js"
export * from "./Destinations.vue?vue&type=script&lang=js"

import "./Destinations.vue?vue&type=style&index=0&id=309e302a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309e302a"]])

export default __exports__